import Api from "../config/api";

export const findConveniosByAtivo = (unidadeId) =>
  Api.post("", {
    query: `{
            convenios: findAllConvenioList(searchDTO: {
                unidadeId: ${unidadeId || 0},
                ativo: true,
                sortDir: "ASC",
                sortField: "descricao"
            }) {
                id
                descricao
                convenioAgendamentoTipo {
                    agendamentoTipo {
                        id
                    }
                    valor
                }
                convenioSistema {
                  id
                }
            }
        }`,
  });

export const findAllConvenio = (
  search = "",
  sort = { sortDir: "ASC", sortField: "descricao" },
  ativo = true,
  pageNumber = 0,
  pageSize = 30
) =>
  Api.post("", {
    query: `
        query ($searchDTO: SearchDTOInput) {
            findAllConvenio(searchDTO: $searchDTO) {
                last
                content {
                    id
                    descricao
                    ativo
                    registroAns
                    codigoUnidade
                    convenioProcedimentos{
                        id
                        convenio{
                            id
                        }
                        procedimento{
                            id
                            nome
                        }
                        valor
                        valorVigente {
                        valor
                        id
                        dataInicioVigencia
                        dataFimVigencia
                      }
                    }
                    produtoConvenios{
                        produto{
                            id
                        }
                        convenio{
                            id
                        }
                        valor
                    }
                    convenioSistema {
                      id
                    }
                }
            }
        }
    `,
    variables: {
      searchDTO: {
        search,
        ...sort,
        ativo,
        pageNumber,
        pageSize,
      },
    },
  });

export const findConvenios = (
  search = "",
  sort = { sortDir: "ASC", sortField: "descricao" },
  ativo = true,
  pageNumber = 0,
  pageSize = 30
) => 
  Api.post("", {
    query: `
        query ($searchDTO: SearchDTOInput) {
            findAllConvenio(searchDTO: $searchDTO) {
                last
                content {
                    id
                    descricao
                    ativo
                    registroAns
                    codigoUnidade
                    convenioSistema {
                      id
                    }
                }
            }
        }
    `,
    variables: {
      searchDTO: {
        search,
        ...sort,
        ativo,
        pageNumber,
        pageSize,
      },
    }
  })

export const saveConvenio = async (convenio) => {
  const method = convenio.id ? "updateConvenio" : "createConvenio";

  const response = await Api.post("", {
    query: `
            mutation ($convenio: ConvenioInput) {
                ${method}(convenio: $convenio) {
                    id
                    descricao
                    ativo
                    registroAns
                    codigoUnidade
                    convenioProcedimentos {
                        convenio {
                          id
                        }
                        procedimento {
                          id
                        }
                        valor
                    }
                    convenioAgendamentoTipo {
                        agendamentoTipo {
                            id
                        }
                        valor
                    }
                }
            }
        `,
    variables: { convenio },
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }
};

export const findByIdConvenio = async (id) => {
  const response = await Api.post("", {
    query: `
        query ($id: Long) {
            findByIdConvenio(id: $id) {
                descricao
                ativo
                unidade {
                  id
                }
                registroAns
                codigoUnidade
                convenioProcedimentos {
                    id
                    convenio {
                      id
                    }
                    procedimento {
                      id
                    }
                    valorVigente {
                    dataInicioVigencia
                    dataFimVigencia
                    valor
                    id
                    }  
                    valor                 
                }
                produtoConvenios {
                    produto {
                        id
                        nome
                    }
                    valor
                }
                convenioAgendamentoTipo {
                    motivoCancelamentoTipo
                    agendamentoTipo {
                      id
                    }
                    valor
                }
                convenioSistema {
                    id
                    descricao
                    label:descricao
                    value:id
                    convenioLogo {
                      urlDownload
                    }
                }
            }
        }
    `,
    variables: { id },
  });
  return response.data.data.findByIdConvenio;
};

export const findAllConvenioRelatorio = (
  search = "",
  sort = { sortDir: "ASC", sortField: "descricao" },
  ativo = null,
  pageNumber = 0,
  pageSize = 999
) =>
  Api.post("", {
    query: `
        query ($searchDTO: SearchDTOInput) {
            findAllConvenio(searchDTO: $searchDTO) {
                last
                content {
                    id
                    descricao
                }
            }
        }
    `,
    variables: {
      searchDTO: {
        search,
        ...sort,
        ativo,
        pageNumber,
        pageSize,
      },
    },
  });

export const listarConveniosTipoConsulta = ({
  search = "",
  sort = { sortDir: "ASC", sortField: "descricao" },
  ativo = true,
  pageNumber = 0,
  pageSize = 30,
}) =>
  Api.post("", {
    query: `
        query ($searchDTO: SearchDTOInput, $pageableDTO: PageableDTOInput) {
          findAllConvenio(searchDTO: $searchDTO, pageableDTO: $pageableDTO) {
            last
            content {
              id
              descricao
              ativo
              convenioAgendamentoTipo {
                agendamentoTipo {
                  id
                }
                motivoCancelamentoTipo
              }
            }
          }
        }
    `,
    variables: {
      searchDTO: {
        search,
        ativo,
      },
      pageableDTO: {
        ...sort,
        pageNumber,
        pageSize,
      },
    },
  });

export const listaConveniosAtivo = () =>
  Api.post("", {
    query: `{
            convenios: findAllConvenioList(searchDTO: {
                ativo: true,
                sortDir: "ASC",
                sortField: "descricao"
            }) {
                id
                descricao
            }
        }`,
  });

export const findAllConvenioSistema = async (variables) => {
  const response = await Api.post("", {
    query: `
            query ($search: String, $pageableDTO: PageableDTOInput) {
                findAllConvenioSistema(search: $search, pageableDTO: $pageableDTO) {
                    last
                    content {
                        id
                        descricao
                    }
                }
            }
        `,
    variables: variables,
  });

  const { last, content } = response.data.data.findAllConvenioSistema;
  const customContent = content.map((item) => {
    return {
      ...item,
      value: item.id,
      label: item.descricao,
    };
  });

  return {
    last,
    content: customContent,
  };
};

export const convenioNomeJaExistente = async (search) => {
  const response = await Api.post("", {
    query: `
      {
        convenioNomeJaExistente(search: "${search}")
      }`,
  });

  return response.data.data.convenioNomeJaExistente;
};

export const findAllConvenioSistemaByConvenio = async (variables) => {
  const response = await Api.post("", {
    query: `
         query ($search: String, $vinculado: Boolean, $pageableDTO: PageableDTOInput) {
            findAllConvenioSistemaByConvenio(search: $search, vinculado: $vinculado, pageableDTO: $pageableDTO) {
              last
              content {
                id
                descricao
                convenioLogo {
                  id
                  urlDownload
                }
              }
            }
          }
          
         `,
    variables: variables,
  });

  const { last, content } = response.data.data.findAllConvenioSistemaByConvenio;
  const customContent = content.map((item) => {
    return {
      ...item,
      value: item.id,
      label: item.descricao,
    };
  });

  return {
    last,
    content: customContent,
  };
};

export const findValorByConvenioAndProcedimento = async (variables) => {
  const response = await Api.post("",{
    query :`query FindValorByConvenioAndProcedimento($convenio: ConvenioInput, $procedimento: ProcedimentoInput) {
    findValorByConvenioAndProcedimento(convenio: $convenio, procedimento: $procedimento) {
    valorVigente {
      dataInicioVigencia
      dataFimVigencia
      id
      valor
    }
    id
    valores {
      valor
      id
      dataInicioVigencia
      dataFimVigencia
    }
  }
}`, variables: variables
  }) 
  if(response.data.errors){
    throw response.data.errors[0]
  }else{
    return response.data.data.findValorByConvenioAndProcedimento
  }
}

export const modifyValorByConvenioAndProcedimento = async ({variables}) => {
  const response =await Api.post("",{
    query:`mutation ModifyValorByConvenioAndProcedimento($convenioProcedimento: ConvenioProcedimentoInput) {
    modifyValorByConvenioAndProcedimento(convenioProcedimento: $convenioProcedimento) {
    convenio {
      id
      descricao
    }
    id
    procedimento {
      id
      nome
    }
    valor
    valorVigente {
      dataInicioVigencia
      dataFimVigencia
      id
      valor
    }
    valores {
      id
      dataInicioVigencia
      dataFimVigencia
      valor
    }
  }
}`, variables:variables
  })
  if(response.data.erros){
    throw response.data.errors[0]
  }else{
    return response.data.data.modifyValorByConvenioAndProcedimento.content
  }
}

export const findAllConvenioPlano = async(
 variables
) => {
  const response = await  Api.post("", {
    query: `
      query ($searchDTO: SearchDTOInput) {
        findAllConvenioList(searchDTO: $searchDTO) {
          id
          descricao
        }
      }
    `,
    variables: variables
  });

  if(response.data.erros){
    throw response.data.errors[0]
  }else{
    return response.data.data.findAllConvenioList
  }
}

export const findAllLigacaoConvenio = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($tipoLigacaoEntidadesValores: TipoLigacaoEntidadesValores, $search: String, $entidadeId: String, $pageableDto: PageableDTOInput) {
        findAllLigacaoConvenio(tipoLigacaoEntidadesValores: $tipoLigacaoEntidadesValores, search: $search, entidadeId: $entidadeId, pageableDTO: $pageableDto) {
          last
          content {
            dataFimVigencia
            dataInicioVigencia
            descricao
            id
            valor
          }
        }
      }`,
    variables: variables,
  });

  if(response.data.erros){
    throw response.data.errors[0]
  }else{
    return response.data.data.findAllLigacaoConvenio
  }
};
 

export const findConveniosBySujeitoAtencaoId = async (sujeitoAtencaoId, unidadeId) => {
  const response = await Api.post('', {
    query: `
      query ($unidadeId: Long, $sujeitoAtencaoId: UUID, $pageableDTO: PageableDTOInput) {
        findAllConvenioPacientePublico(unidadeId: $unidadeId, sujeitoAtencaoId: $sujeitoAtencaoId, ativo: true, pageableDTO: $pageableDTO) {
          content {
            id
            descricao
          }
        }
      }
    `,
    variables: {
      unidadeId,
      sujeitoAtencaoId,
      pageableDTO: { pageNumber: 0, pageSize: 100, sortDir: 'ASC', sortField: 'descricao' }
    }
  });
  return response.data.data.findAllConvenioPacientePublico?.content || [];
};
